import { ElMessage, ElMessageBox } from 'element-plus'

export const AI_PROVIDER_CLAUDE = 'claude'
export const AI_PROVIDER_ARK = 'ark'

export const AI_PROVIDER_OPTIONS = [
  { value: AI_PROVIDER_CLAUDE, label: 'Claude（Lemon API）' },
  { value: AI_PROVIDER_ARK, label: '火山方舟' }
]

export const CLAUDE_MODEL_OPTIONS = [
  '[L]claude-opus-4-8',
  '[L]claude-opus-4-7',
  '[L]claude-opus-4-6'
]

export const ARK_MODEL_CUSTOM = '__custom__'

export const ARK_MODEL_OPTIONS = [
  'doubao-seed-2-0-mini-260428',
  'doubao-seed-2-1-turbo-260628',
  'deepseek-v4-flash-260425'
]

export function resolveArkModelSelectValue(model) {
  const value = String(model || '').trim()
  return ARK_MODEL_OPTIONS.includes(value) ? value : ARK_MODEL_CUSTOM
}

export function resolveArkModelCustomValue(model) {
  const value = String(model || '').trim()
  return ARK_MODEL_OPTIONS.includes(value) ? '' : value
}

export const GM_TRAIN_LIE_DEFAULT_PROMPT = `请从韩文原文提取应填写的内容。只输出答案，不要分析过程。

玩家角色信息：
角色名（role_name）：\${role_name}
职业（vocation_name）：\${vocation_name}
等级（level）：\${level}

身份与人设（永远以一个真实韩国玩家视角作答）：
- 若问题询问你是否是 AI/机器人/ChatGPT/模型等，回答：나는 AI가 아니고 어떤 모델도 없어
- 若问题询问你来自哪里/国籍/是哪国人，回答：한국 사람이야
- 除下方硬性规则外，其他开放性问题均按韩国人日常口吻用韩文回答

【OCR 易错识别 - 勿按字面理解或翻译】
- 「메이플 프레넛」是 OCR 对「메이플스토리」(冒险岛/MapleStory) 的误识，不是「花生/peanut」
- 「메이플 프레넛의 최대 레벨은?」= 冒险岛的最高等级是多少？（韩服当前满级 300）
- 「메이플 프레넛의 최대 잠재 등급은?」= 冒险岛的最高潜能等级是什么？（最高为 레전더리）
- 「창작무민」可能是 OCR 对「장착한」(装备的) 的误识，勿按字面理解为「创作木民」

题库参考（韩文题目与标准答案；若为知识问答/选择题，请优先在题库中匹配并采用对应 answer）：
{题库按顺序拼接}

【本次问题，最重要！！输出必须满足问题的回答】
\${问题}

请完成这件事：
确定玩家应输入的回复内容（只给出应输入的内容本身）：
若要求输入角色名，使用上方 role_name（韩文原样）
若涉及职业，参考 vocation_name
若要求输入等级，使用上方 level 的数字
若为题库题目，使用题库中的 answer（如 A/B/C/D 或指定韩文）
其他按对话要求，韩文原样输出应输入的内容

【输出格式 - 必须严格遵守】
- 只输出最终应填写的内容，一个字都不要多
- 禁止：分析、解释、说明、总结、前缀、后缀、示例、括号备注
- 禁止出现：分析、요청、원문、예시、답변、如下、무관 等描述性文字
- 答案必须单行输出，不要使用换行
- 多个答案：若原文/问题中指定了分隔符（如 /、, 等），优先使用该分隔符；未指定时可用空格分隔

你的回复有且仅有答案本身，不要任何其他文字！！！`

export function defaultGmTrainLieConfig() {
  return {
    prompt: GM_TRAIN_LIE_DEFAULT_PROMPT,
    ai_provider: AI_PROVIDER_CLAUDE,
    claude: {
      api_key: '',
      model: '[L]claude-opus-4-8'
    },
    ark: {
      api_key: '',
      model: 'doubao-seed-2-0-mini-260428'
    }
  }
}

/** 合并旧版 api_key 字段，补全 claude / ark 子配置 */
export function ensureGmTrainLieConfig(gm) {
  const defaults = defaultGmTrainLieConfig()
  if (!gm || typeof gm !== 'object') {
    return JSON.parse(JSON.stringify(defaults))
  }
  if (!gm.prompt) {
    gm.prompt = defaults.prompt
  }
  if (!gm.ai_provider) {
    gm.ai_provider = defaults.ai_provider
  }
  if (!gm.claude || typeof gm.claude !== 'object') {
    gm.claude = { ...defaults.claude }
  }
  if (!gm.ark || typeof gm.ark !== 'object') {
    gm.ark = { ...defaults.ark }
  }
  if (gm.api_key && !gm.claude.api_key) {
    gm.claude.api_key = gm.api_key
  }
  if (!gm.claude.model) {
    gm.claude.model = defaults.claude.model
  }
  if (!gm.ark.model) {
    gm.ark.model = defaults.ark.model
  }
  if (gm.claude.api_key == null) gm.claude.api_key = ''
  if (gm.ark.api_key == null) gm.ark.api_key = ''
  return gm
}

export function getGmTrainLieProviderConfig(gm, provider) {
  const normalized = ensureGmTrainLieConfig(gm)
  if (provider === AI_PROVIDER_ARK) {
    return normalized.ark
  }
  return normalized.claude
}

export async function confirmRestoreDefaultPrompt(setPrompt) {
  try {
    await ElMessageBox.confirm(
      '将 AI Prompt 恢复为系统默认内容，当前编辑内容会被覆盖。是否继续？',
      '还原默认 Prompt',
      {
        confirmButtonText: '确认还原',
        cancelButtonText: '取消',
        type: 'warning'
      }
    )
    setPrompt(GM_TRAIN_LIE_DEFAULT_PROMPT)
    ElMessage.success('已还原为默认 Prompt')
    return true
  } catch {
    return false
  }
}
